import { Injectable, inject } from '@angular/core';
import {
  BasePageMetaResolver,
  PageHeadingResolver,
  PageMetaResolver,
  PageTitleResolver,
  PageType,
} from '@spartacus/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class CustomLoginPageMetaResolver
  extends PageMetaResolver
  implements PageTitleResolver, PageHeadingResolver
{
  protected basePageMetaResolver = inject(BasePageMetaResolver);

  constructor() {
    super();
    this.pageType = PageType.CONTENT_PAGE;
    this.pageTemplate = 'LoginPageTemplate';
  }

  resolveHeading(): Observable<string | undefined> {
    return of('');
  }

  resolveTitle(): Observable<string | undefined> {
    return this.basePageMetaResolver.resolveTitle();
  }
}
